<template>

    <div class="flex flex-col w-full h-full bg-white" >

        <div class="myenter mt-10">

            <ring-loader v-if="$apollo.loading && this.showLoader"/>
        </div>

        <div v-if="businessInfo != null">

            <div class="classPageRow">

                <label class="mr-2 lg:mr-5"><strong>{{$t('business.customerBusinessLogo')}} </strong></label>

                <img v-if="businessInfo.logo != ''" :src="businessInfo.logo" class="ml-1 lg:ml-5 rounded-lg" height="200" id="profileImage" ref="brandImageRef" width="200"/>
                <img v-else src="@/assets/images/full-logo.jpg" class="ml-1 lg:ml-5 rounded-lg" height="200" id="profileImage" ref="brandImageRef" width="200"/>
            </div>

            <div class="classPageRow">
                            
                    <label class="mr-5"><strong>{{$t('business.businessName')}} </strong></label>

                    <label
                    class="classPageDetailsLabel">
                    {{businessInfo.name}}</label>
            </div>
            
            <div class="myCenter">

                <div class="mt-2 mycardBorder myMapLink myCenter">
                    <a :href="`${businessInfo.location.url}`"
                    class="">
                        {{$t('sessions.googleLink')}}
                    </a>
                </div>
            </div>

            <div class="classPageRow">
                            
                <label class="lg:me-5" ><strong>{{$t('business.location')}} </strong></label>

                <div class="border border-gray-300 me-2">
                    <my-google-maps-view :location="businessInfo.location"></my-google-maps-view>
                </div>
            </div>

            <div class="classPageRow">
                
                <label class="mr-5"><strong>{{$t('profile.phone')}} </strong></label>

                    <label
                    class="classPageDetailsLabel">
                    
                    <a v-if="businessInfo.phone !=0" :href="`tel:${businessInfo.phone}`">
                    {{businessInfo.phone}}
                    </a>
                    <a v-else>
                    {{brandInfo.phone}}
                  </a>
                </label>
            </div>

            <div class="classPageRow">
                        
                <label class="mr-5"><strong>{{$t('business.country')}} </strong></label>

                <label
                class="classPageDetailsLabel">
                {{businessInfo.location.country}}</label>
            </div>

            <div class="classPageRow">
                            
                <label class="mr-5"><strong>{{$t('classes.locationName')}}  </strong></label>

                <label
                class="classPageDetailsLabel">
                {{businessInfo.location.name}}</label>
            </div>
            

            <div class="classPageRow">
                        
                <label class="mr-5"><strong>{{$t('business.address')}} </strong></label>

                <label
                class="classPageDetailsLabel">
                {{businessInfo.address}}</label>
            </div>
        </div>
        
        <div v-else class="ml-1 mr-1 mb-1 lg:ml-20 lg:mr-20 lg:mb-20 items-center rounded-full mt-40">

            <label v-if="!showLoader"><strong>{{$t('business.noBusinessIsAvailable')}}</strong></label>
        </div>

        <div v-if="!isFromPage && businessInfo != null" class="sticky top-0 h-screen">

            <!-- <business-fitness-tabs :myBusinessId="businessInfo.id" :hideSessionsTitle="true"/> -->
        </div>            

        <div class="myFixedPaddingHeight">

        </div>
    </div>
</template>

<script>

import myGoogleMapsView from '../../components/MyGoogleMapsView';

import myQueries from '../../hasura/myQueries';

import componentsHelpers from '../../classes/componentHelpers';

// import businessFitnessTabs from './BusinessFitnessTabs'

// import businessSessions from '../../views-v2/BusinessSessions'
// import businessSessions from '../../views-v2/Sessions'

export default {

    created(){

        //console.log(`business is ${JSON.stringify(this.businessInfo)}`);

        // console.log(`this.isFromPage is ${JSON.stringify(this.isFromPage)}`);
// 
    },

    async mounted(){

    // console.log(`userId: ${this.userId}`);

    this.fetchParameters();
    },
    props: {

    // businessInfo: {

    //     type: Object,
    //     default: () => ({}) 
    // },

    isFromPage: false,

    businessId: 0,

    userId: 0,

    },

    components: {

        myGoogleMapsView,
        // businessSessions,
        // businessFitnessTabs
    },

    methods: {

      fetchParameters(){

        const parameters = this.$route.query;

        let businessId = 0;

        if(typeof parameters.businessId != 'undefined')
        {
            

          businessId = Number(parameters.businessId);

            // console.log(`businessId from url: ${businessId}`);

        }else if(this.businessId != 0 && typeof this.businessId != 'undefined'){


          businessId = this.businessId;

        //   console.log(`businessId from props: ${businessId}`);

        }else{


            // console.log(`businessId by default: ${businessId}`);

        }

        this.myBusinessId = businessId;

      },
  },

  computed: {


  },

  apollo:{

      withUser:{

            query: myQueries.token_and_user_query,

            update(data){

                try{

                    // console.log(`data: ${JSON.stringify(data)}`);

                    this.tokenId = data.token[0].id;

                    if(typeof data.token[0].user != 'undefined' && data.token[0].user!= null){

                            this.user = data.token[0].user;

                            this.myUserId = this.user.id;
                        }
                        else{

                            componentsHelpers.toastIt(this.$t('sessions.completeYourProfile'),  2, 'outline', true);

                            this.disablePage = true;
                        }
                    }catch(error){

                    componentsHelpers.sendError(this.$apollo, this.userId,'MyPages-BusinessPage', 'apollo', 'withUser query - 1', error);

                    componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
                }
            },

            error(error){
                
                if(this.userInfoError == ''){

                    componentsHelpers.sendError(this.$apollo, 0,'MyPages-BusinessPage', 'apollo', 'withUser query - 2', error);

                    componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
                }
            },
            skip(){

                return typeof this.userId != 'undefined';
            }
        },

        business: {
        
            query: myQueries.one_business_query,

            variables(){

                return{

                    businessId: this.myBusinessId
                }
            },

            update(data){

                // console.log(`business: ${JSON.stringify(data)}`);

                this.showLoader = false;

                if(data.business.length > 0){

                    this.businessInfo = data.business[0];
                }

                //  console.log(`this.businessInfo: ${JSON.stringify(this.businessInfo)}`);

            },

            error(error){
                
                if(this.businessError == ''){
                
                    componentsHelpers.sendError(this.$apollo, this.userId,'MyPages-BusinessPage', 'apollo', 'business', error);

                    componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);

                    this.userInfoError = JSON.stringify(error);
                }
            },
            
            skip(){
                
                // console.log(`typeof this.businessId: ${typeof this.businessId}`);
                // console.log(`this.myBusinessId: ${this.myBusinessId}`);

                return this.myBusinessId == 0;
            },
        },
  },

  data: function(){

    return {


        showLoader: true,

        businessName: '',

        businessInfo: null,

        myUserId: this.userId,

        myBusinessId: 0,

        userInfoError: '',

        businessError: '',

        isNotFromBrowse: this.isFromBrowse ? false : true
    }
  },

  
}
</script>

<style lang="scss">

label{
  width: 150px;
}


</style>